export const validate = (val, rules) => {
  let isValid = true;
  for (let rule in rules) {
    switch (rule) {
      case "isEmail":
        isValid = isValid && emailValidator(val);
        break;
      case "minLength":
        isValid = isValid && minLengthValidator(val, rules[rule]);
        break;
      case "notEmpty":
        isValid = isValid && notEmptyValidator(val);
        break;
      case "isName":
        isValid = isValid && nameValidator(val);
        break;
      case "isDate":
        isValid = true;
        break;
      case "isNumber":
        isValid = isValid && numberValidator(val);
        break;
      case "isString":
        isValid = isValid && stringValidator(val);
        break;
      default:
        isValid = true;
    }
  }

  return isValid;
};

const emailValidator = val => {
  return /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/.test(
    val
  );
};

const minLengthValidator = (val, minLength) => {
  return val.length >= minLength;
};

const notEmptyValidator = val => {
  return val.trim() !== "";
};

const nameValidator = val => {
  return /^[a-zA-Z ]{2,30}$/.test(val);
};

const numberValidator = val => {
  return /^\d+$/.test(val);
};

const stringValidator = val => {
  return true;
};

export const placeholders = {
  email: "Email",
  password: "Password",
  courseID: "Course ID",
  lesson: "Lesson",
  module: "Module",
  title: "Title",
  content: "Content"
};

export const errorStrings = {
  email: "Email is not valid.",
  password:
    "Password is not valid. It should be greater than 8 characters and include alphanumeric characters.",
  courseID: "CourseID is not valid",
  lesson: "Lesson is not valid",
  module: "Module is not valid",
  title: "Title is not valid",
  coontent: "Content is not valid"
};
